function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useObservabilityConfig, useProject } from "@sail/observability";
import { useUpdatedRef } from "@sail/react";
import { useCallback, useEffect, useRef } from "react";
import useLogFetch from "./useLogFetch";
import fullFetch from "../shared/fetch/fullFetch";
import { REQUEST_SOURCE_HEADER, getRequestSourceHeader, getRequestSourceInformation } from "../shared/requestSource";
import useDataConfig from "../../public/useDataConfig";
export default function useImperativeBaseFetch(format) {
    var _useObservabilityConfig;
    const dataConfig = useDataConfig();
    var _dataConfig_fetch;
    // Use refs instead of standard values so that we can return a stable
    // callback and still update request values when they change.
    const fetchRef = useUpdatedRef((_dataConfig_fetch = dataConfig.fetch) !== null && _dataConfig_fetch !== void 0 ? _dataConfig_fetch : globalThis.fetch);
    const logFetchRef = useUpdatedRef(useLogFetch(dataConfig.observability));
    const projectRef = useUpdatedRef(useProject());
    const serviceRef = useUpdatedRef((_useObservabilityConfig = useObservabilityConfig()) === null || _useObservabilityConfig === void 0 ? void 0 : _useObservabilityConfig.service);
    const abortControllerRef = useRef(new AbortController());
    useEffect(()=>{
        const abortController = abortControllerRef.current;
        return ()=>{
            abortController.abort();
        };
    }, []);
    return useCallback((url, options = {})=>{
        return new Promise((resolve)=>{
            const requestSourceInformation = getRequestSourceInformation({
                service: serviceRef.current,
                project: projectRef.current,
                component: options.component
            });
            const requestSource = getRequestSourceHeader(requestSourceInformation);
            const fullOptions = _object_spread_props(_object_spread({}, options), {
                headers: _object_spread({
                    [REQUEST_SOURCE_HEADER]: requestSource
                }, options.headers),
                signal: abortControllerRef.current.signal
            });
            const fetch = options.prepareFetch ? options.prepareFetch(fetchRef.current) : fetchRef.current;
            const promise = fullFetch(url, fullOptions, fetch, format, logFetchRef.current);
            promise.then((result)=>{
                if (result !== null) {
                    resolve(result);
                }
            });
        });
    }, [
        // Just references here! We want to keep the callback reference stable.
        fetchRef,
        logFetchRef,
        projectRef,
        serviceRef,
        format
    ]);
}

//# sourceMappingURL=useImperativeBaseFetch.js.map